import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TableRowRoot } from './TableRow.styled';
// Component.
// -----------------------------------------------------------------------------
const TableRow = forwardRef(({ children, selected = false, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TableRowRoot, { ref: ref, selected: selected, className: `${selected && 'selected'}`, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableRow.displayName = 'TableRow';
export default TableRow;
//# sourceMappingURL=TableRow.js.map